import {
	Collapse as CollapseUI,
	UnmountClosed as UnmountClosedUI,
	CollapseProps as CollapseUiProps,
} from "react-collapse";
import * as React from "react";

export type CollapseProps = CollapseUiProps;

export function Collapse({ initialStyle, ...props }: CollapseProps) {
	return (
		<CollapseUI
			initialStyle={{ height: 0, overflow: "hidden", ...initialStyle }}
			{...props}
		/>
	);
}

// Same as Collapse, but unmounts its children while closed.
export function UnmountClosed({ initialStyle, ...props }: CollapseProps) {
	return (
		<UnmountClosedUI
			initialStyle={{ height: 0, overflow: "hidden", ...initialStyle }}
			{...props}
		/>
	);
}
